<template>
  <component
    :is="svgIcon"
    :style="{ width: size, height: size, minWidth: size }"
    :width="size"
    :height="size"
    :class="[`icon-color_${color}`]"
  />
</template>

<script>
  export default {
    name: 'Icon',
    data() {
      return {
        svgIcon: () => import(`@/assets/icons/component/Icon=${this.type}.svg`),
      };
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: 'primary',
        validator: (color) =>
          ['primary', 'secondary', 'oncolor', 'accent', 'warning', 'error', 'success'].includes(
            color
          ),
      },
      size: {
        type: [Number, String],
        default: 24,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .icon {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;

    &-color {
      &_primary * {
        fill: $text-primary;
      }
      &_secondary * {
        fill: $icon-secondary;
      }
      &_oncolor * {
        fill: white;
      }
      &_accent * {
        fill: $primary500;
      }
      &_warning * {
        fill: $warning500;
      }
      &_error * {
        fill: $semantic-error;
      }
      &_success * {
        fill: $semantic-success;
      }
    }
  }
</style>
